<template>
  <div class="content">
    <form class="form-horizontal" @submit.prevent="onSubmit">
      <card class="text-left">
        <template slot="header">
          <h4 class="card-title">리워드 위젯 {{ rewardId ? "상세" : "등록" }}</h4>
        </template>

        <div class="row mb-3">
          <label class="col-sm-2 col-form-label">노출여부</label>
          <div class="col-sm-10 d-flex align-items-center" style="padding-top: 10px">
            <base-switch v-model="isVisible" on-text="ON" off-text="OFF" type="primary"></base-switch>
          </div>
        </div>

        <div class="row mb-3">
          <label class="col-sm-2 col-form-label">이미지</label>
          <div class="col-sm-10">
            <BlipFileUploadZone :upload-category="6" :maxFiles="1" :fileUrl="imageFileUrl" @onChangeFileIds="onFileIdChange" />
            <small class="text-muted">JPG, GIF 업로드 가능</small>
          </div>
        </div>

        <div class="row mb-3">
          <label class="col-sm-2 col-form-label">대상 투표</label>
          <div class="col-sm-10">
            <el-select v-model="pollId" placeholder="투표를 선택하세요" filterable clearable style="width: 100%" @change="onPollChange">
              <el-option v-for="poll in polls" :key="poll.id" :label="poll.title" :value="poll.id">
                <span>{{ poll.title }}</span>
                <span style="float: right; color: #8492a6; font-size: 13px">{{ poll.status }}</span>
              </el-option>
            </el-select>
          </div>
        </div>

        <div class="row mb-3">
          <label class="col-sm-2 col-form-label">초이스 타이틀</label>
          <div class="col-sm-10">
            <div class="row">
              <div class="col-sm-4">
                <base-input placeholder="한국어" v-model="titleKo">
                  <span slot="helpBlock" class="form-text" />
                </base-input>
              </div>
              <div class="col-sm-4">
                <base-input placeholder="English" v-model="titleEn">
                  <span slot="helpBlock" class="form-text" />
                </base-input>
              </div>
              <div class="col-sm-4">
                <base-input placeholder="日本語" v-model="titleJa">
                  <span slot="helpBlock" class="form-text" />
                </base-input>
              </div>
            </div>
          </div>
        </div>

        <div class="row mb-3">
          <label class="col-sm-2 col-form-label">리워드 위치</label>
          <div class="col-sm-10">
            <div class="row">
              <div class="col-sm-4">
                <base-input placeholder="한국어" v-model="locationKo">
                  <span slot="helpBlock" class="form-text" />
                </base-input>
              </div>
              <div class="col-sm-4">
                <base-input placeholder="English" v-model="locationEn">
                  <span slot="helpBlock" class="form-text" />
                </base-input>
              </div>
              <div class="col-sm-4">
                <base-input placeholder="日本語" v-model="locationJa">
                  <span slot="helpBlock" class="form-text" />
                </base-input>
              </div>
            </div>
          </div>
        </div>

        <div class="row mb-3">
          <label class="col-sm-2 col-form-label">링크</label>
          <div class="col-sm-10">
            <div class="row mb-2">
              <div class="col-sm-6">
                <label class="col-form-label pt-0 pl-0" style="font-size: 0.78rem; font-weight: 700; color: #525f7f">링크 구분</label>
                <div class="d-flex align-items-center" style="gap: 12px">
                  <base-radio name="INTERNAL" inline v-model="linkType">내부</base-radio>
                  <base-radio name="EXTERNAL" inline v-model="linkType">외부</base-radio>
                </div>
              </div>
              <div class="col-sm-6">
                <label class="col-form-label pt-0 pl-0" style="font-size: 0.78rem; font-weight: 700; color: #525f7f">링크 옵션</label>
                <LinkSelect @linkChangeEvent="getLink" class="link-selection" link-model="link" :allowed-link-type="linkType" allow-custom platform-aware />
              </div>
            </div>
            <div class="mb-2">
              <label class="d-flex align-items-center pl-0" style="gap: 8px; font-size: 0.78rem; font-weight: 700; color: #525f7f">
                <span>앱 링크</span>
                <span class="badge badge-pill" :class="hasAppLink ? 'badge-success' : 'badge-secondary'">{{ hasAppLink ? "노출" : "미노출" }}</span>
              </label>
              <base-input placeholder="딥링크 또는 HTTPS · 비우면 웹 전용" v-model="link">
                <span slot="helpBlock" class="form-text" />
              </base-input>
            </div>
            <div>
              <label class="d-flex align-items-center pl-0" style="gap: 8px; font-size: 0.78rem; font-weight: 700; color: #525f7f">
                <span>웹 링크</span>
                <span class="badge badge-pill" :class="hasWebLink ? 'badge-success' : 'badge-secondary'">{{ hasWebLink ? "노출" : "미노출" }}</span>
              </label>
              <base-input placeholder="HTTP 또는 HTTPS · 비우면 앱 전용" v-model="webLink">
                <span slot="helpBlock" class="form-text" />
              </base-input>
            </div>
          </div>
        </div>

        <div class="row mb-3">
          <label class="col-sm-2 col-form-label">시간설정</label>
          <div class="col-sm-5">
            <label class="col-form-label pt-0 pl-0">노출시작시간</label>
            <base-input placeholder="시작시간">
              <el-date-picker type="datetime" placeholder="시작시간" v-model="publishedAt"></el-date-picker>
            </base-input>
          </div>
        </div>

        <div class="row mb-3">
          <label class="col-sm-2 col-form-label">노출 아티스트</label>
          <div class="col-sm-10">
            <ArtistSelect
              v-if="!rewardId || dataLoaded"
              :show-title="false"
              :initial-unit-id="unitId"
              :initial-member-id="artistId"
              @memberChangeEvent="onArtistChange"
            />
          </div>
        </div>
      </card>

      <div class="d-flex justify-content-center" style="gap: 8px">
        <base-button v-if="!rewardId" native-type="submit" type="success">등록</base-button>
        <base-button v-if="rewardId" native-type="submit" type="success">수정</base-button>
        <base-button @click="goBack" type="default">취소</base-button>
        <base-button v-if="rewardId" @click="onDelete" type="danger">삭제</base-button>
      </div>
    </form>
  </div>
</template>
<script>
import { BaseInput, BaseRadio, BaseSwitch, Card } from "@/components/index";
import swal from "sweetalert2";
import BlipFileUploadZone from "@/components/BlipFileUploadZone";
import { Toast } from "@/util/Toast";
import LinkSelect from "@/pages/Components/LinkSelect.vue";
import ArtistSelect from "@/pages/Components/ArtistSelect.vue";

export default {
  components: {
    Card,
    BaseInput,
    BaseRadio,
    BaseSwitch,
    LinkSelect,
    BlipFileUploadZone,
    ArtistSelect,
  },
  async created() {
    await this.getPollList();
    if (this.$route.query.rewardId) {
      this.rewardId = Number(this.$route.query.rewardId);
      await this.getData();
    }
    this.dataLoaded = true;
  },
  data() {
    return {
      polls: [],
      pollId: null,
      dataLoaded: false,
      rewardId: null,
      titleKo: null,
      titleEn: null,
      titleJa: null,
      locationKo: null,
      locationEn: null,
      locationJa: null,
      imageFileId: null,
      imageFileUrl: null,
      link: null,
      webLink: null,
      linkType: "INTERNAL",
      publishedAt: null,
      unitId: null,
      artistId: null,
      isVisible: true,
    };
  },
  computed: {
    hasAppLink() {
      return Boolean(this.link && this.link.trim());
    },
    hasWebLink() {
      return Boolean(this.webLink && this.webLink.trim());
    },
  },
  methods: {
    onPollChange(pollId) {
      const poll = this.polls.find((p) => p.id === pollId);
      if (poll) {
        this.titleKo = poll.title;
        this.titleEn = poll.titleI18n?.en ?? null;
        this.titleJa = poll.titleI18n?.ja ?? null;
      }
    },
    async getPollList() {
      return this.$axios.get("/rewards/polls").then((res) => {
        this.polls = res.data.data?.items ?? [];
      });
    },
    onArtistChange(param) {
      this.unitId = param.unitId;
      this.artistId = param.memberId;
    },
    onFileIdChange(newFileIds) {
      this.imageFileId = newFileIds[0];
    },
    getLink(param) {
      if (param.custom) return;
      const linkModel = param.linkModel.split(".");
      this[linkModel[0]] = param.value;
      this.webLink = param.webValue ?? this.webLink;
    },
    inferLinkType(link) {
      return /^(https?:\/\/|blip(dev)?:\/\/external(?:[/?]|$))/i.test(link || "") ? "EXTERNAL" : "INTERNAL";
    },
    async getData() {
      return this.$axios.get(`/rewards/${this.rewardId}`).then((res) => {
        const data = res.data.data;
        if (data) {
          this.pollId = data.pollId;
          this.titleKo = data.title;
          this.titleEn = data.titleI18n?.en ?? null;
          this.titleJa = data.titleI18n?.ja ?? null;
          this.locationKo = data.locationName;
          this.locationEn = data.locationNameI18n?.en ?? null;
          this.locationJa = data.locationNameI18n?.ja ?? null;
          this.imageFileId = data.imageFileId;
          this.link = data.link ?? null;
          this.webLink = data.webLink ?? null;
          this.linkType = data.linkType || this.inferLinkType(data.link);
          this.publishedAt = data.publishedAt ?? null;
          this.unitId = data.unitId;
          this.artistId = data.artistId ?? null;
          this.isVisible = data.isVisible === true || data.isVisible === 1;
          if (this.imageFileId) {
            this.imageFileUrl = window.Endpoints.imageServerUrl + this.imageFileId;
          }
        }
      });
    },
    async setWidgetState(state) {
      return this.$axios
        .put(`/rewards/${this.rewardId}/state`, {
          params: { state },
        })
        .then(() => {
          Toast.success("상태가 변경되었습니다");
        });
    },
    async onSubmit() {
      if (!this.imageFileId && !this.imageFileUrl) {
        Toast.error("이미지는 필수입니다");
        return;
      }
      if (!this.publishedAt) {
        Toast.error("시간을 입력해주세요");
        return;
      }

      if (!this.unitId) {
        Toast.error("아티스트를 선택해주세요");
        return;
      }
      const params = {
        pollId: this.pollId,
        unitId: this.unitId,
        artistId: this.artistId || null,
        imageFileId: this.imageFileId,
        title: this.titleKo,
        titleI18n: { en: this.titleEn, ja: this.titleJa },
        locationName: this.locationKo,
        locationNameI18n: { en: this.locationEn, ja: this.locationJa },
        link: this.link || null,
        webLink: this.webLink || null,
        linkType: this.linkType,
        isVisible: this.isVisible,
        publishedAt: this.publishedAt,
      };
      if (this.rewardId) {
        return this.$axios.put(`/rewards/${this.rewardId}`, { params }).then(() => {
          Toast.success("위젯이 수정되었습니다");
        });
      } else {
        return this.$axios.post("/rewards", { params }).then(() => {
          Toast.success("위젯이 등록되었습니다");
          this.goBack();
        });
      }
    },
    async onDelete() {
      const confirmed = await swal.fire({
        title: "위젯 삭제 확인",
        text: "위젯을 삭제하시겠습니까?",
        type: "warning",
        showCancelButton: true,
        customClass: {
          confirmButton: "btn btn-danger btn-fill",
          cancelButton: "btn btn-cancel btn-fill",
        },
        confirmButtonText: "삭제",
        cancelButtonText: "취소",
        buttonsStyling: false,
      });
      if (!confirmed.value) return;
      await this.$axios.delete(`/rewards/${this.rewardId}`);
      Toast.success("위젯이 삭제되었습니다");
      this.goBack();
    },
    goBack() {
      this.$router.push("/poll/rewards");
    },
  },
};
</script>
<style scoped lang="scss">
::v-deep .el-select {
  .el-input__inner {
    color: #333;

    &::placeholder {
      color: #aaa;
    }
  }

  .el-select__caret,
  .el-input__icon {
    color: #666;
  }
}
</style>
